// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    EmailEmailIsUnsubscribedDefaultResponse,
    EmailEmailSendDefaultResponse,
    EmailEmailUnsubscribeDefaultResponse,
    GatewayError,
    IsUnsubscribedRequestModel,
    SendRequestModel,
    UnsubscribeBySourceNameRequestModel,
    UnsubscribeRequestModel,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgeEmailApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param isUnsubscribedRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async emailIsUnsubscribed (isUnsubscribedRequestModel: IsUnsubscribedRequestModel, xProgramId?: string): Promise<AxiosResponse<EmailEmailIsUnsubscribedDefaultResponse>> {
        const _url_ = '/edge/email/IsUnsubscribed';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'isUnsubscribedRequestModel' is not null or undefined
        if (isUnsubscribedRequestModel === null || isUnsubscribedRequestModel === undefined) {
            throw new Error('Required parameter isUnsubscribedRequestModel was null or undefined when calling emailIsUnsubscribed.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(isUnsubscribedRequestModel, "IsUnsubscribedRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<EmailEmailIsUnsubscribedDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EmailEmailIsUnsubscribedDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param sendRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async emailSend (sendRequestModel: SendRequestModel, xProgramId?: string): Promise<AxiosResponse<EmailEmailSendDefaultResponse>> {
        const _url_ = '/edge/email/Send';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'sendRequestModel' is not null or undefined
        if (sendRequestModel === null || sendRequestModel === undefined) {
            throw new Error('Required parameter sendRequestModel was null or undefined when calling emailSend.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(sendRequestModel, "SendRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<EmailEmailSendDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EmailEmailSendDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param unsubscribeRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async emailUnsubscribe (unsubscribeRequestModel: UnsubscribeRequestModel, xProgramId?: string): Promise<AxiosResponse<EmailEmailUnsubscribeDefaultResponse>> {
        const _url_ = '/edge/email/Unsubscribe';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'unsubscribeRequestModel' is not null or undefined
        if (unsubscribeRequestModel === null || unsubscribeRequestModel === undefined) {
            throw new Error('Required parameter unsubscribeRequestModel was null or undefined when calling emailUnsubscribe.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(unsubscribeRequestModel, "UnsubscribeRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<EmailEmailUnsubscribeDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EmailEmailUnsubscribeDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param unsubscribeBySourceNameRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async unsubscribeUnsubscribeBySourceName (unsubscribeBySourceNameRequestModel: UnsubscribeBySourceNameRequestModel, xProgramId?: string): Promise<AxiosResponse<any>> {
        const _url_ = '/edge/email/v2/Unsubscribe/unsubscribeBySourceName';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'unsubscribeBySourceNameRequestModel' is not null or undefined
        if (unsubscribeBySourceNameRequestModel === null || unsubscribeBySourceNameRequestModel === undefined) {
            throw new Error('Required parameter unsubscribeBySourceNameRequestModel was null or undefined when calling unsubscribeUnsubscribeBySourceName.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(unsubscribeBySourceNameRequestModel, "UnsubscribeBySourceNameRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<any>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "any");
        }
        return response;
    }
}
